// Lightweight pub-sub bridge so the axios 402 interceptor (a non-React module)
// can trigger the React UpgradeModalProvider. One listener is enough since the
// provider mounts exactly once at the App root.

let listener = null;

export const setUpgradeModalListener = (fn) => {
  listener = fn;
};

export const clearUpgradeModalListener = () => {
  listener = null;
};

export const triggerUpgradeModal = (detail) => {
  if (typeof listener === 'function') {
    try {
      listener(detail);
    } catch (e) {
      console.error('UpgradeModal handler error', e);
    }
  }
};
